import { render } from "./ThreadModal.vue?vue&type=template&id=2d88d0a4&ts=true"
import script from "./ThreadModal.vue?vue&type=script&lang=ts"
export * from "./ThreadModal.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__